<p>asset-service-record works!</p>
